import { render, staticRenderFns } from "./MarkdownItem.vue?vue&type=template&id=ea8baa46&scoped=true"
import script from "./MarkdownItem.vue?vue&type=script&lang=js"
export * from "./MarkdownItem.vue?vue&type=script&lang=js"
import style0 from "./MarkdownItem.vue?vue&type=style&index=0&id=ea8baa46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8baa46",
  null
  
)

export default component.exports